// External libraries
import { capitalizeFirst, isObject } from '@checkout/react-components';

// Internal modules
import { getContent } from '@/lib';

// Copied from hermione
const mapDataToProps = cartDetails => {
  if (!cartDetails) {
    return {};
  }

  const {
    amounts,
    description,
    items,
    merchant,
    noteToBuyer,
    intent,
  } = cartDetails;

  return {
    amounts: formatAmounts(amounts),
    currencyCode: amounts.total.currencyCode,
    description,
    isAuthOrderTransaction: intent === 'AUTHORIZE' || intent === 'ORDER',
    items: formatItems(items),
    merchantName: getMerchantName(merchant),
    noteToBuyer,
  };
};

const flattenAmount = type => {
  return Number(type?.currencyValue) ? type?.currencyFormat : '';
};

const addDescriptions = amounts => {
  return Object.keys(amounts).reduce((result, type) => {
    const description =
      getContent(`cartDropdown.${type}`) || capitalizeFirst(type);
    const amount = {
      amount: amounts[type],
      description,
    };

    return Object.assign(result, { [type]: amount });
  }, {});
};

const filterAmounts = amounts => {
  return Object.keys(amounts).reduce((result, current) => {
    const validAmount = flattenAmount(amounts[current]);
    if (validAmount) {
      result[current] = validAmount;
    }

    return result;
  }, {});
};

const formatAmounts = amounts => {
  return addDescriptions(filterAmounts(amounts));
};

const formatItems = items => {
  return items.map(item => ({
    ...item,
    details: parseItemDetails(item.details),
    total: flattenAmount(item.total),
    unitPrice: flattenAmount(item.unitPrice),
  }));
};

const parseItemDetails = details => {
  const itemDetails = isObject(details) ? Object.entries(details) : [];
  return itemDetails.length ? itemDetails : null;
};

const getMerchantName = ({ name } = {}) => {
  return name || getContent('base.theMerchant');
};

export { mapDataToProps };
